import { Component, OnInit } from "@angular/core";
import { AuthService } from "projects/sepidz-web-framework/src/lib/services";
@Component({
  selector: "nb-logout",
  templateUrl: "./logout.component.html",
})
export class LogoutComponent implements OnInit {
  redirectDelay: number = 0;
  strategy: string = "";

  constructor(protected authService: AuthService) {}

  ngOnInit(): void {
    this.logout();
  }

  logout(): void {
    this.authService.logout();
    this.authService.redirectLogoutUser();
  }
}
